export default function setPageTitle(title: string, translator: (key: string) => string): void {
    let pageTitle = title ?? translator('error.pageNotFound');
    pageTitle = pageTitle[0].toUpperCase() + pageTitle.substring(1);

    document.title = pageTitle + ' - ' + translator('xerScheduleToolkit');
}
